// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","social-buttons":"social-buttons","social-buttons__facebook":"social-buttons__facebook","social-buttons__email":"social-buttons__email","social-buttons__flowers":"social-buttons__flowers","facebook":"facebook","social-buttons__fb-span":"social-buttons__fb-span"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Shared/SocialButtons/css/SocialButtons.styl
// module id = 1493
// module chunks = 0